import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LMLoggerService } from './lm-logger.service';

@Injectable()
export class LMDataService {
  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService
  ) {}

  public getRecord(url: string): Observable<LMDataView> {
    // console.log('refresh record: ' + url.substring(0, url.indexOf('?')));
    return this.http.get<LMDataView>(url).pipe(
      // TODO: keep catchError for now, in the future lmLoggerService.error
      // may do more than just console.error e.g. send errors back to the server
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      })
    );
  }

  public getTemplateRecords(url: string): Observable<LMDataViewSet> {
    return <Observable<LMDataViewSet>> this.http.get(url).pipe(
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }

  public getSubPanelRecords(url: string): Observable<LMDataViewSet> {
    return  <Observable<LMDataViewSet>> this.http.get(url).pipe(
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }

  public getPageData(url: string): Observable<LMPageDataResponse> {
    return  <Observable<LMPageDataResponse>> this.http.get(url).pipe(
      catchError(error => {
        this.lmLoggerService.error(error);
        return throwError(error || 'Server error');
      }));
  }
}
